<template>
  <div class="basic_wrap choose_wrap">
    <div class="red_top_bg">
      <div class="page-brand">
       <!-- <img
          class="page-brand-logo"
          src="../images/ban5/slogo.png"
          alt=""
        > -->
      </div>
      <div class="big_tit">
        {{ $t('sky.xuan') }}
      </div>
      <div
        class="language"
        @click="$router.push('/language')"
      >
        <img :src="require('../images/language/'+lang+'.png')">
      </div>
      <div class="top_right" />
    </div>
		
		
   <!-- <van-swipe
      class="banner-swipe"
      :autoplay="3000"
      lazy-render
    >
      <van-swipe-item
        v-for="(item, index) in displayBanners"
        :key="index"
      >
        <img
          :src="item.src || item[lang]"
          class="banner-image campaign-banner"
          width="100%"
        >
      </van-swipe-item>
    </van-swipe> -->
	<van-swipe
	  class="home_swipe"
	  :autoplay="3000"
	  lazy-render
	>
	  <van-swipe-item
	    v-for="(item, index) in displayBanners"
	    :key="index"
	  >
	    <img
	      :src="item.src || item[lang]"
	      class="home_banner_image"
	      alt=""
	    >
	  </van-swipe-item>
	</van-swipe>
		
		
    <div
      class="head-tabs vip-tabs"
      aria-label="VIP"
    >
      <span
        class="tab-item "
        :class="cur==0?'active':''"
        @click="cur=0;resetGirls();"
      >VIP</span>
    </div>
    <div class="tab-content">
      <van-empty
        v-if="empty"
        :description="$t('orders.noOrders')"
      />
      <div
        v-if="!empty"
        class="box"
      />
      <van-list
        v-model="loading"
        :finished="finished"
        :offset="100"
        style="padding-bottom: 60px;"
        :loading-text="$t('pro2.loading')"
        @load="loadGirls"
      >
        <div
          v-if="girls.length"
          class="pblBox"
        >
          <div
            v-for="(item, index) in girls"
            :key="index"
            style="width: calc(50% - 5px);"
            @click="$router.push('/vprofile/'+item.id)"
          >
            <div class="releaseItem">
              <div class="imgBox">
                <div
                  class="van-image"
                  style="width: 100%; height: 100%;"
                >
                  <img
                    :src="item.pic"
                    class="van-image__img"
                  >
                </div>
                <span><i>{{ $t('sky.gaoduan') }}</i></span>
                <div class="infoBox">
                  <i
                    class="van-icon van-icon-location"
                    style="font-size: 14px;"
                  /><span
                    style="font-size: 12px; margin: 0px 0px 0px 2px;"
                  />
                  <div class="wantyuebtn">
                    {{ $t('sky.yue') }}
                  </div>
                </div>
              </div>
            <!--  <div
                class="tagBox"
                style="color: rgb(102, 102, 102);"
              >
                <span
                  v-if="item.keys[0]"
                  class="van-tag  van-tag--primary"
                >{{ item.keys[0] }}</span>
                <span
                  v-if="item.keys[1]"
                  class="van-tag  van-tag--success"
                >{{ item.keys[1] }}</span>
                <span
                  v-if="item.keys[2]"
                  class="van-tag  van-tag--danger"
                >{{ item.keys[2] }}</span>
                <span
                  v-if="item.keys[3]"
                  class="van-tag  van-tag--warning"
                >{{ item.keys[3] }}</span>
              </div> -->
              <div class="di">
                <div>
                  <span style="display: inline-block; margin-right: 2px; width: 12px; height: 12px; border-radius: 50%; background: rgb(239, 186, 143);" />
                  <span>{{ item.name }}</span>
                </div>
                <div>
                  <i
                    class="van-icon van-icon-like"
                    style="color: rgb(220, 99, 161);"
                  /><span>{{ item.zan }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
	
	import Vue from "vue";
	import {
		Swipe,
		SwipeItem,
		Empty,List,Card,ShareSheet 
	} from "vant";
	import Fetch from "../../utils/fetch";
	import romanticDiningBanner from "../images/home-romantic-dining-banner.png";
	import luxuryArrivalBanner from "../images/home-luxury-arrival-banner.png";
	Vue.use(Empty).use(List).use(Card).use(ShareSheet);
	export default {
		name: "Choose",
		components: {
			VanSwipe: Swipe,
			VanSwipeItem: SwipeItem,
		},
		data() {
			return {
				lang: this.$i18n.locale || "zh_cn",
				data: null,
				loading:false,
				page:1,
				girls:[],
				banner:null,
				localBanners: [
					// { src: romanticDiningBanner },
					// { src: luxuryArrivalBanner }
				],
				cur:0,
				area:null,
				arealist:null,
				islogin: false,
				locationsel: false,
				type:0,
				finished:false,
				empty: false,
				requestLock: false,
			};
		},
		created() {
			this.$parent.footer("girl",true);
		},
		computed: {
			displayBanners() {
				return this.localBanners.concat(Array.isArray(this.banner) ? this.banner : []);
			}
		},
		mounted() {
			this.islogin = localStorage.getItem('token')!=null;
			if(!this.islogin){
				this.$router.push("/login");
			}
			this.getBanner();
		},
		methods: {
			getBanner() {
				Fetch('/index/int').then((r) => {
					this.banner = r.data.banner;
				});
			},
			resetGirls() {
				this.page = 1;
				this.girls = [];
				this.finished = false;
				this.empty = false;
				this.requestLock = false;
				this.loading = true;
				this.loadGirls();
			},
			loadGirls() {
				if (this.requestLock || this.finished) {
					this.loading = false;
					return;
				}
				this.requestLock = true;
				Fetch('/index/girls', {
					page: this.page
				}).then((r) => {
					var rows = r.data && r.data.list ? r.data.list : [];
					for (let i = 0; i < rows.length; i++) {
						rows[i].keys = rows[i].keystr ? rows[i].keystr.split('|') : [];
					}
					if (rows.length > 0) {
						this.girls = this.girls.concat(rows);
						this.page++;
					}
					this.empty = this.girls.length === 0;
					this.finished = !(r.data && r.data.has_more);
					this.loading = false;
					this.requestLock = false;
				}).catch(() => {
					this.loading = false;
					this.requestLock = false;
					this.finished = true;
				});
			}
		},
	};
</script>

<style lang="less" scoped>
	.red_top_bg {
		.language{
			position: absolute;
			top: 4px;
			left: 5px;
			height: 36px;
			img{
				height: 100%;
			}
		}
	}
	.basic_wrap {
		height: 100vh;
		overflow: hidden;
		display: flex;
		flex-direction: column;
	}
	.banner-swipe {
		flex: 0 0 auto;
	}
	.head-tabs {
		flex: 0 0 auto;
	}
	.tab-content {
		flex: 1;
		overflow-y: auto;
		padding-bottom: 84px;
		-webkit-overflow-scrolling: touch;
	}
	/deep/ .van-list {
		min-height: 100%;
	}
	.pblBox{
	    display: flex;
	    justify-content: space-between;
	    padding: 10px 20px;
	    flex-wrap: wrap
	}

.releaseItem {
	width: 100%;
	margin-bottom: 15px
}

.releaseItem .imgBox {
	position: relative;
	overflow: hidden;
	border-radius: 8px;
	// height: 67vw
}

.releaseItem .imgBox>span {
	position: absolute;
	z-index: 9;
	background-color: #ebcaaf;
	color: #8d684b;
	transform: rotate(45deg);
	width: 90px;
	height: 90px;
	top: -50px;
	right: -50px;
}

.releaseItem .imgBox>span>i {
	position: absolute;
	bottom: 5px;
	left: 50%;
	transform: translateX(-50%);
	font-weight: 700;
	font-size: 12px
}

.releaseItem .imgBox .infoBox {
	position: absolute;
	bottom: 0;
	left: 0;
	background: rgba(0,0,0,.4);
	display: flex;
	align-items: center;
	color: #fff;
	width: 100%;
	height: 40px;
	padding: 0 10px
}

.releaseItem .imgBox .infoBox .wantyuebtn {
	border: 1px solid #fff;
	padding: 5px 8px;
	border-radius: 8px;
	opacity: .9;
	font-size: 12px;
	margin-left: auto
}

.releaseItem .tagBox {
	font-size: 12px;
	margin: 5px 0
}

.releaseItem .di {
	display: flex;
	justify-content: space-between;
	font-size: 12px;
	color: #666
}
/deep/ .van-tag{
	margin: 3px;
}

/* Black-gold page treatment aligned with the home screen. */
.choose_wrap {
	min-height: 100vh;
	background:
		radial-gradient(circle at 96% 3%, rgba(124, 4, 5, .34), transparent 26%),
		linear-gradient(180deg, #1b0c08 0, #120907 28%, #120907 100%);
	color: #f5dfbd;
}

.choose_wrap .red_top_bg {
	position: relative;
	flex: 0 0 66px;
	height: 66px;
	background: linear-gradient(105deg, #120907, #32140d) !important;
	border-bottom: 1px solid rgba(185, 135, 59, .36);
	box-shadow: 0 5px 16px rgba(0, 0, 0, .28);
}

.page-brand {
	position: absolute;
	left: 14px;
	top: 12px;
	height: 42px;
	display: flex;
	align-items: center;
}

.page-brand-logo {
	max-width: 104px;
	height: 38px;
	object-fit: contain;
	filter: drop-shadow(0 2px 6px rgba(0, 0, 0, .45));
}

.choose_wrap .big_tit {
	position: absolute;
	left: 50%;
	top: 0;
	transform: translateX(-50%);
	display: flex;
	align-items: center;
	height: 66px;
	color: #e6b669;
	font-size: 17px;
	font-weight: 600;
	letter-spacing: .5px;
	text-shadow: 0 1px 8px rgba(230, 182, 105, .2);
}

.choose_wrap .language {
	left: auto;
	right: 13px;
	top: 15px;
	width: 36px;
	height: 36px;
	padding: 5px;
	border: 1px solid rgba(230, 182, 105, .65);
	border-radius: 50%;
	background: rgba(39, 15, 10, .82);
	box-sizing: border-box;
	box-shadow: 0 3px 10px rgba(0, 0, 0, .28);
}

.choose_wrap .language img {
	width: 100%;
	height: 100%;
	object-fit: contain;
}

.banner-swipe {
	width: calc(100% - 20px);
	height: 146px;
	margin: 12px auto 0;
	overflow: hidden;
	border: 1px solid rgba(185, 135, 59, .55);
	border-radius: 14px;
	background: #1b100d;
	box-shadow: 0 10px 20px rgba(0, 0, 0, .3);
}

.banner-swipe .banner-image {
	display: block;
	width: 100%;
	height: 146px;
	object-fit: cover;
	object-position: center;
	filter: sepia(.22) saturate(.82) brightness(.78) contrast(1.1);
}

/deep/ .banner-swipe .van-swipe__indicators {
	bottom: 8px;
}

/deep/ .banner-swipe .van-swipe__indicator {
	width: 7px;
	height: 7px;
	background: rgba(245, 223, 189, .48);
}

/deep/ .banner-swipe .van-swipe__indicator--active {
	width: 18px;
	border-radius: 7px;
	background: #e6b669;
}

.head-tabs {
	margin: 13px 10px 0;
	padding: 4px;
	border: 1px solid rgba(185, 135, 59, .45);
	border-radius: 12px;
	background: #1b100d;
	box-shadow: 0 7px 15px rgba(0, 0, 0, .2);
}

.head-tabs .tab-item {
	display: block;
	padding: 9px 12px;
	border-radius: 8px;
	color: #c9ab86;
	font-size: 14px;
	letter-spacing: 1.6px;
	text-align: center;
}

.head-tabs .tab-item.active {
	color: #ffe4a5;
	background: linear-gradient(90deg, #660b0b, #98311a);
	box-shadow: inset 0 1px 0 rgba(255, 230, 170, .16);
}

/* Keep the selector explicit: this page has only one category and should read as a label, not an empty card. */
.choose_wrap .head-tabs {
	display: flex;
	align-items: center;
	height: 42px;
	margin-top: 10px;
	padding: 3px;
	box-sizing: border-box;
}

.choose_wrap .head-tabs .tab-item {
	width: 100%;
	padding: 7px 12px;
	line-height: 20px;
	box-sizing: border-box;
}

.tab-content {
	padding-top: 12px;
	background: transparent;
}

.pblBox {
	gap: 12px 10px;
	padding: 2px 10px 88px;
}

.releaseItem {
	margin-bottom: 0;
	padding: 6px;
	border: 1px solid rgba(185, 135, 59, .5);
	border-radius: 13px;
	background: #1b100d;
	box-shadow: 0 10px 18px rgba(0, 0, 0, .2);
	box-sizing: border-box;
}

.releaseItem .imgBox {
	height: 210px;
	border: 1px solid rgba(230, 182, 105, .4);
	border-radius: 9px;
	background: #120907;
}

.releaseItem .imgBox .van-image,
.releaseItem .imgBox .van-image__img {
	border-radius: 8px;
}

.releaseItem .imgBox .van-image__img {
	object-fit: cover;
	filter: sepia(.25) saturate(.78) brightness(.8) contrast(1.08);
}

.releaseItem .imgBox::after {
	position: absolute;
	inset: 0;
	background: linear-gradient(180deg, transparent 45%, rgba(18, 9, 7, .7));
	content: '';
	pointer-events: none;
}

.releaseItem .imgBox > span {
	background: #64150d;
	color: #f4d188;
	box-shadow: 0 1px 0 rgba(255, 232, 173, .34);
}

.releaseItem .imgBox .infoBox {
	z-index: 2;
	height: 38px;
	padding: 0 8px;
	background: rgba(18, 9, 7, .72);
	color: #f5dfbd;
}

.releaseItem .imgBox .infoBox .wantyuebtn {
	border-color: rgba(230, 182, 105, .8);
	border-radius: 7px;
	background: rgba(124, 4, 5, .7);
	color: #ffe4a5;
	box-shadow: inset 0 1px 0 rgba(255, 229, 165, .14);
}

.releaseItem .di {
	min-height: 31px;
	padding: 6px 2px 0;
	color: #f5dfbd;
	font-size: 12px;
	line-height: 24px;
}

.releaseItem .di > div:first-child {
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.releaseItem .di span[style] {
	background: #e6b669 !important;
	box-shadow: 0 0 6px rgba(230, 182, 105, .35);
}

.releaseItem .di .van-icon-like {
	color: #e6b669 !important;
}

.banner-swipe .campaign-banner {
	filter: none;
}

.banner-swipe .remote-banner {
	filter: sepia(.72) saturate(.68) hue-rotate(340deg) brightness(.58) contrast(1.16);
}

/deep/ .van-empty {
	padding-top: 56px;
}

/deep/ .van-empty__description,
/deep/ .van-list__finished-text,
/deep/ .van-list__loading {
	color: #c9ab86;
}

/* Member directory on a light ivory surface. */
.choose_wrap, .basic_wrap { min-height: 100vh; background: linear-gradient(160deg, #fffdf7, #fff5e3 60%, #f7e6c5); color: #533126; }.choose_wrap .red_top_bg { background: rgba(255, 252, 245, .98) !important; border-bottom: 1px solid rgba(190, 139, 52, .45); box-shadow: 0 4px 14px rgba(125, 82, 35, .08); }.choose_wrap .big_tit { color: #873126; text-shadow: none; }.choose_wrap .page-brand-logo { filter: none; }.choose_wrap .language { border-color: rgba(190, 139, 52, .48); background: #fff7df; box-shadow: 0 3px 10px rgba(125, 82, 35, .08); }.banner-swipe { border-color: rgba(190, 139, 52, .45); background: #fffdf8; box-shadow: 0 9px 20px rgba(125, 82, 35, .08); }.banner-swipe .banner-image { filter: none; }.head-tabs, .choose_wrap .head-tabs { border-color: rgba(190, 139, 52, .46); background: #fffdf8; box-shadow: 0 7px 15px rgba(125, 82, 35, .08); }.head-tabs .tab-item { color: #815c45; }.head-tabs .tab-item.active { color: #fff8e8; background: linear-gradient(105deg, #a6233d, #ca5a5b); box-shadow: 0 4px 10px rgba(126, 28, 47, .16); }.releaseItem { border-color: rgba(190, 139, 52, .46); background: #fffdf8; box-shadow: 0 9px 20px rgba(125, 82, 35, .08); }.releaseItem .imgBox { border-color: rgba(190, 139, 52, .38); background: #fff7df; }.releaseItem .imgBox .van-image__img { filter: none; }.releaseItem .imgBox::after { background: linear-gradient(180deg, transparent 45%, rgba(83, 49, 38, .32)); }.releaseItem .imgBox > span { background: #a6233d; color: #fff8e8; }.releaseItem .imgBox .infoBox { background: rgba(255, 253, 248, .86); color: #63352c; }.releaseItem .imgBox .infoBox .wantyuebtn { border-color: rgba(166, 35, 61, .42); background: #a6233d; color: #fff8e8; }.releaseItem .di { color: #63352c; }.releaseItem .di .van-icon-like, .releaseItem .di span[style] { color: #a6233d !important; background: #fff0ed !important; }

/* A single VIP category should read as a complete, touch-friendly tab. */
.choose_wrap .vip-tabs {
	display: flex;
	align-items: center;
	width: calc(100% - 28px);
	min-height: 52px;
	height: 52px;
	margin: 16px 14px 2px;
	padding: 5px;
	border: 1px solid rgba(190, 139, 52, .5);
	border-radius: 14px;
	background: #fffdf8;
	box-shadow: 0 8px 18px rgba(125, 82, 35, .1);
	box-sizing: border-box;
}

.choose_wrap .vip-tabs .tab-item {
	display: flex;
	flex: 1;
	align-items: center;
	justify-content: center;
	min-height: 40px;
	padding: 0 16px;
	border-radius: 10px;
	font-size: 17px;
	font-weight: 700;
	line-height: 40px;
	letter-spacing: .8px;
	box-sizing: border-box;
}
/deep/ .home_swipe.van-swipe {
  // height: 42vw;
  min-height: 140px;
  // max-height: 188px;
  margin: 12px 10px 0;
  border: 1px solid rgba(190, 139, 52, .58);
  border-radius: 14px;
  box-shadow: 0 12px 25px rgba(126, 84, 29, .16);
}

.home_banner_image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/deep/ .home_swipe .van-swipe__indicators {
  bottom: 8px;
}

/deep/ .home_swipe .van-swipe__indicator {
  width: 6px;
  height: 6px;
  background: rgba(145, 82, 45, .3);
}

/deep/ .home_swipe .van-swipe__indicator--active {
  width: 15px;
  border-radius: 6px;
  background: #b9802e;
}

/* Match the account center's teal, mist-white, and soft-border system. */
.choose_wrap, .basic_wrap { background: linear-gradient(180deg, #f3f9f8, #ebf5f3); color: #123d42; }
.choose_wrap .red_top_bg { background: rgba(255, 255, 255, .97) !important; border-bottom-color: #c7e0dd; box-shadow: 0 4px 14px rgba(10, 73, 79, .07); }
.choose_wrap .big_tit { color: #073f47; }.choose_wrap .language { border-color: #a8d5d0; background: #e8f5f3; box-shadow: 0 3px 10px rgba(10, 73, 79, .08); }
.banner-swipe { border-color: #c9e1de; background: #fff; box-shadow: 0 9px 20px rgba(12, 75, 79, .08); }
.head-tabs, .choose_wrap .head-tabs, .choose_wrap .vip-tabs { border-color: #c9e1de; background: rgba(255, 255, 255, .95); box-shadow: 0 8px 18px rgba(12, 75, 79, .08); }
.head-tabs .tab-item { color: #60797c; }.head-tabs .tab-item.active { background: #073f47; box-shadow: 0 4px 10px rgba(11, 70, 76, .16); color: #fff; }
.releaseItem { border-color: #c9e1de; background: rgba(255, 255, 255, .95); box-shadow: 0 9px 20px rgba(12, 75, 79, .08); }.releaseItem .imgBox { border-color: #a8d5d0; background: #e8f5f3; }
.releaseItem .imgBox::after { background: linear-gradient(180deg, transparent 45%, rgba(7, 63, 71, .28)); }.releaseItem .imgBox > span, .releaseItem .imgBox .infoBox .wantyuebtn { border-color: #0c7b83; background: #073f47; color: #fff; }
.releaseItem .imgBox .infoBox { background: rgba(255, 255, 255, .88); color: #123d42; }.releaseItem .di { color: #173f44; }.releaseItem .di .van-icon-like, .releaseItem .di span[style] { color: #08646d !important; background: #e8f5f3 !important; }
/deep/ .van-empty__description, /deep/ .van-list__finished-text, /deep/ .van-list__loading { color: #60797c; }

/* Keep the directory grid stable at every viewport width. */
/deep/ .home_swipe.van-swipe { height: clamp(140px, 38vw, 220px); min-height: 0; margin: 14px 14px 0; border-color: #c9e1de; border-radius: 16px; background: #fff; box-shadow: 0 10px 22px rgba(12, 75, 79, .1); }
.home_banner_image { height: 100%; object-fit: cover; object-position: center; }
/deep/ .home_swipe .van-swipe__indicator { background: rgba(8, 100, 109, .28); }
/deep/ .home_swipe .van-swipe__indicator--active { background: #0d8d94; }
.choose_wrap .vip-tabs { margin-top: 14px; margin-bottom: 4px; }
.pblBox { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 14px 12px; padding: 6px 14px 88px; }
.pblBox > div { width: auto !important; min-width: 0; }
.releaseItem { padding: 7px; border-radius: 16px; }
.releaseItem .imgBox { height: auto; aspect-ratio: 3 / 4; border-radius: 12px; }
.releaseItem .imgBox .van-image, .releaseItem .imgBox .van-image__img { border-radius: 11px; }
.releaseItem .di { min-height: 34px; padding: 7px 3px 0; }

@media (min-width: 640px) {
  .pblBox { max-width: 620px; margin: 0 auto; }
}
</style>
